import "./skeleton.css";

const Skeleton = () => {
  return <div className="skeleton"></div>;
};

export default Skeleton;
